exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".index_countDown_reKMB {\n  color: #666;\n  font-family: \"SFProText-Medium\";\n  font-weight: 500;\n  font-size: 0.75rem;\n  line-height: 0.75rem;\n  transform: scale(0.83);\n  margin-top: 0.0625rem;\n}\n\n.index_countDown_reKMB span {\n  display: inline-block;\n  width: 3.5rem;\n}\n", ""]);

// Exports
exports.locals = {
	"countDown": "index_countDown_reKMB"
};